import { createAction } from 'redux-actions';
import {
    CHARTIQ_ADD_COMPARISON,
    CHARTIQ_ADD_COMPARISON_AND_SAVE,
    CHARTIQ_CHANGE_CHART_DATA,
    CHARTIQ_CHANGE_DRAWINGS,
    CHARTIQ_CHANGE_VECTOR_LINE_PARAMS,
    CHARTIQ_CHANGE_VECTOR_PARAMS,
    CHARTIQ_CHANGE_VECTOR_STYLE,
    CHARTIQ_CLEAR,
    CHARTIQ_DRAW,
    CHARTIQ_DRAWINGS_CHANGED,
    CHARTIQ_FETCH_DATA,
    CHARTIQ_IMPORT_DRAWINGS,
    CHARTIQ_IMPORT_LAYOUT,
    CHARTIQ_LAYOUT_CHANGED,
    CHARTIQ_LAYOUT_CHANGED_AND_SAVE,
    CHARTIQ_REDID,
    CHARTIQ_REDO,
    CHARTIQ_REMOVE_COMPARISON,
    CHARTIQ_REMOVE_COMPARISON_AND_SAVE,
    CHARTIQ_SAVE_LAYOUT,
    CHARTIQ_SET_CHART_CONTAINER,
    CHARTIQ_SET_CHART_TYPE,
    CHARTIQ_SET_CHART_TYPE_AND_SAVE,
    CHARTIQ_SET_CONTAINER,
    CHARTIQ_SET_PERIODICITY,
    CHARTIQ_SET_PERIODICITY_WITH_LOADER,
    CHARTIQ_SET_RESPONSIVE_SIZE,
    CHARTIQ_SET_SHARE_STATUS,
    CHARTIQ_SET_SPAN_WITH_LOADER,
    CHARTIQ_SET_SYMBOL,
    CHARTIQ_SET_SYMBOL_AND_SAVE,
    CHARTIQ_SET_TIME_ZONE,
    CHARTIQ_SHARE_CHART,
    CHARTIQ_SUBSCRIBE_CALLBACK,
    CHARTIQ_TOGGLE_CROSSHAIRS,
    CHARTIQ_TOGGLE_CROSSHAIRS_AND_SAVE,
    CHARTIQ_TOGGLE_TIMEZONE_MODAL,
    CHARTIQ_UNDID,
    CHARTIQ_UNDO,
    CHARTIQ_UNDO_STAMPS,
} from './constants';

// REDUCER
export const addComparison = createAction(
    CHARTIQ_ADD_COMPARISON,
    (params: any) => params,
);

// SAGA
export const addComparisonAndSave = createAction(
    CHARTIQ_ADD_COMPARISON_AND_SAVE,
    (params: any) => params,
);

// SAGA
export const changeDrawings = createAction(
    CHARTIQ_CHANGE_DRAWINGS,
    (params: any) => params,
);

// REDUCER
export const changeVectorLineParams = createAction(
    CHARTIQ_CHANGE_VECTOR_LINE_PARAMS,
    (params: any) => params,
);

// REDUCER
export const changeVectorParams = createAction(
    CHARTIQ_CHANGE_VECTOR_PARAMS,
    (params: any) => params,
);

// REDUCER
export const changeVectorStyle = createAction(
    CHARTIQ_CHANGE_VECTOR_STYLE,
    (params: any) => params,
);

// REDUCER
export const changingChartData = createAction(
    CHARTIQ_CHANGE_CHART_DATA,
	(changing: boolean) => changing,
);

// RECUDER???
export const clear = createAction(
    CHARTIQ_CLEAR,
    (params: any) => params,
);

// REDUCER
export const draw = createAction(
    CHARTIQ_DRAW,
    (params: any) => params,
);

// REDUCER
export const drawingsChanged = createAction(
    CHARTIQ_DRAWINGS_CHANGED,
    (params: any) => params,
);

// REDUCER
export const importDrawings = createAction(
    CHARTIQ_IMPORT_DRAWINGS,
    (params: any) => params,
);

// REDUCER
export const layoutChanged = createAction(
    CHARTIQ_LAYOUT_CHANGED,
    (params: any) => params,
);

// SAGA
export const layoutChangedAndSave = createAction(
    CHARTIQ_LAYOUT_CHANGED_AND_SAVE,
    (params: any) => params,
);

// REDUCER
export const loadLayout = createAction(
    CHARTIQ_IMPORT_LAYOUT,
    (params: any) => params,
);

// REDUCER
export const redid = createAction(
    CHARTIQ_REDID,
    (params: any) => params,
);

// SAGA
export const redo = createAction(
    CHARTIQ_REDO,
    (params: any) => params,
);

// REDUCER
export const removeComparison = createAction(
    CHARTIQ_REMOVE_COMPARISON,
    (params: any) => params,
);

// SAGA
export const removeComparisonAndSave = createAction(
    CHARTIQ_REMOVE_COMPARISON_AND_SAVE,
    (params: any) => params,
);

// REDUCER
export const saveLayout = createAction(
    CHARTIQ_SAVE_LAYOUT,
    (params: any) => params,
);

// NOT NEEDED???
export const setChartContainer = createAction(
    CHARTIQ_SET_CHART_CONTAINER,
    (params: any) => params,
);

// REDUCER
export const setChartType = createAction(
    CHARTIQ_SET_CHART_TYPE,
    (params: any) => params,
);

// SAGA
export const setChartTypeAndSave = createAction(
    CHARTIQ_SET_CHART_TYPE_AND_SAVE,
    (params: any) => params,
);

// NOT NEEDED???
export const setContainer = createAction(
    CHARTIQ_SET_CONTAINER,
    (params: any) => params,
);

// REDUCER
export const setPeriodicity = createAction(
    CHARTIQ_SET_PERIODICITY,
	(params: any) => params,
);

// SAGA
export const setPeriodicityWithLoader = createAction(
    CHARTIQ_SET_PERIODICITY_WITH_LOADER,
    (params: any) => params,
);

// REDUCER
export const setResponsiveSize = createAction(
    CHARTIQ_SET_RESPONSIVE_SIZE,
	(size: any) => size,
);

// REDUCER
export const setShareStatus = createAction(
    CHARTIQ_SET_SHARE_STATUS,
    (params: any) => params,
);

// SAGA
export const setSpanWithLoader = createAction(
    CHARTIQ_SET_SPAN_WITH_LOADER,
    (params: any) => params,
);

// REDUCER
export const setSymbol = createAction(
    CHARTIQ_SET_SYMBOL,
    (params: any) => params,
);

// SAGA
export const setSymbolAndSave = createAction(
    CHARTIQ_SET_SYMBOL_AND_SAVE,
    (params: any) => params,
);

// SAGA
export const setTimeZone = createAction(
    CHARTIQ_SET_TIME_ZONE,
    (params: any) => params,
);

// REDUCER
export const shareChart = createAction(
    CHARTIQ_SHARE_CHART,
    (params: any) => params,
);

// REDUCER
export const toggleCrosshairs = createAction(
    CHARTIQ_TOGGLE_CROSSHAIRS,
    (params: any) => params,
);

// SAGA
export const toggleCrosshairsAndSave = createAction(
    CHARTIQ_TOGGLE_CROSSHAIRS_AND_SAVE,
    (params: any) => params,
);

// REDUCER
export const toggleTimezoneModal = createAction(
    CHARTIQ_TOGGLE_TIMEZONE_MODAL,
    (params: any) => params,
);

// REDUCER
export const undid = createAction(
    CHARTIQ_UNDID,
    (params: any) => params,
);

// SAGA
export const undo = createAction(
    CHARTIQ_UNDO,
    (params: any) => params,
);

// REDUCER
export const undoStamps = createAction(
    CHARTIQ_UNDO_STAMPS,
    (params: any) => params,
);

// REDUCER
export const subscribeCallback = createAction(
    CHARTIQ_SUBSCRIBE_CALLBACK,
    (params: any) => params,
);

// REDUCER
export const fetchData = createAction(
    CHARTIQ_FETCH_DATA,
    (params: any) => params,
);
